<template>
  <v-card
    class="pa-3 item"
    rounded="xl"
    v-hover="'grey lighten-4'"
    :to="to"
    flat
  >
    <img
      class="d-block rounded-xl item-img"
      :src="files + img + '?resize=1&w=600'"
      :alt="title"
      width="100%"
    />

    <div class="pa-3 item-caption">
      <div class="accent--text text-h6 text-md-h5 font-weight-bold item-title">
        {{ title }}
      </div>

      <div v-if="topics.length" class="mt-3">
        <div
          class="accent--text item-topic"
          v-for="(topic, keyTopics) in topics"
          :key="keyTopics"
        >
          {{ topic }}
        </div>
      </div>

      <div class="d-flex align-center justify-space-between mt-3">
        <div v-if="price">
          <div class="grey--text text-body-2">Valor por Pessoa</div>
          <div class="accent--text text-h6 text-md-h5 font-weight-bold">
            {{ formatPrice(price) }}
          </div>
        </div>

        <div class="ml-auto">
          <v-btn
            color="accent lighten-2"
            width="50px"
            height="50px"
            depressed
            fab
          >
            <v-icon color="white" size="20">
              fa fa-long-arrow-alt-right
            </v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { formatPrice } from "../../utils/formatPrice";

export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    price: {
      type: Number,
      default: 0,
    },
    topics: {
      type: Array,
      default: () => [],
    },
    to: {
      type: String,
      required: true,
    },
  },
  methods: {
    formatPrice,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    aspect-ratio: 4 / 3;
    -o-object-fit: cover;
    object-fit: cover;
  }
}
</style>
